export type UserFilterInfo = {
  isLoading: boolean;
  filterOptions: {
    [key: string]: Array<{ value: string; label: string }>;
  };
  appliedFilters: { [key: string]: string };
};

export type RoleFilterInfo = {
  appliedFilters: { [key: string]: string };
};

export type VendorFilterInfo = {
  appliedFilters: { [key: string]: string };
};

export type InitialFilterStateType = {
  usersListFilter: UserFilterInfo;
  roleListFilter: RoleFilterInfo;
  vendorListFilter: VendorFilterInfo;
};

export const initialFilterState: InitialFilterStateType = {
  usersListFilter: {
    isLoading: false,
    filterOptions: {},
    appliedFilters: {},
  } as UserFilterInfo,
  roleListFilter: {
    appliedFilters: {},
  } as RoleFilterInfo,
  vendorListFilter: {
    appliedFilters: {},
  } as VendorFilterInfo,
  // add other page filters here as well
};
